var _excluded = ["icon", "children"],
    _excluded2 = ["slug", "url"],
    _excluded3 = ["id", "title", "slug", "url", "icon", "onClick"],
    _excluded4 = ["id", "title", "slug", "url", "icon", "onClick", "component"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React, { useState } from "react";
import styled, { css } from "styled-components";
import { MenuSystemIcon } from "@nib/icons";
import { Box, Columns, Column, Hidden, Inline, Container, breakpoint } from "@nib/layout";
import DefaultLogo from "@nib-components/logo";
import Drawer from "@nib/drawer";
import { colorBrandBase, colorLightest } from "@nib-components/theme";
import { LogoLink, NavMenu, baseNavLinkStyles, NavLinkItem, HeaderLink } from "../shared";
var FontZero = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 0;\n"])));
export var NavLink = styled.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n\n  ", "\n"])), baseNavLinkStyles, function (_ref) {
  var isActivePage = _ref.isActivePage;
  return isActivePage && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      ::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        left: 1rem;\n        right: 1rem;\n        display: block;\n        background: ", ";\n        height: 4px;\n      }\n    "])), colorBrandBase);
});
NavLink.displayName = "NavLink";
export var IconLink = function IconLink(_ref2) {
  var Icon = _ref2.icon,
      children = _ref2.children,
      otherProps = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(NavLink, otherProps, /*#__PURE__*/React.createElement(Inline, {
    space: 2,
    verticalAlign: "center"
  }, /*#__PURE__*/React.createElement(FontZero, null, /*#__PURE__*/React.createElement(Icon, {
    size: 20
  })), /*#__PURE__*/React.createElement("span", null, children)));
};
var HiddenBelowXLFlexAbove = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: none;\n\n  ", "\n"])), breakpoint("xl")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: flex;\n  "]))));
HiddenBelowXLFlexAbove.displayName = "HiddenBelowXLFlexAbove";
var FlexBelowXLHiddenAbove = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n\n  ", "\n"])), breakpoint("xl")(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
FlexBelowXLHiddenAbove.displayName = "FlexBelowXLHiddenAbove";
var BoxBorderBottom = styled(Box)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  border-bottom: 1px solid ", ";\n"])), colorLightest);
BoxBorderBottom.displayName = "BoxBorderBottom";
var ColumnPullLeft = styled(Column)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin-right: auto;\n"])));
var UnstyledUnorderedList = styled.ul(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"])));
UnstyledUnorderedList.displayName = "UnstyledUnorderedList";
var FlexListItem = styled.li(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"])));
FlexListItem.displayName = "FlexListItem";

var TierOne = function TierOne(props) {
  return /*#__PURE__*/React.createElement(BoxBorderBottom, {
    background: "white"
  }, props.children);
};

var TierTwo = function TierTwo(props) {
  return /*#__PURE__*/React.createElement(Box, {
    as: "nav",
    background: "white",
    "aria-label": "Main navigation"
  }, props.children);
};

export var PortalHeader = function PortalHeader(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDrawerOpen = _useState2[0],
      setIsDrawerOpen = _useState2[1];

  var Logo = props.logo,
      withContainer = props.withContainer,
      isSingleTier = props.isSingleTier,
      activePage = props.activePage,
      _props$navLinks = props.navLinks,
      navLinks = _props$navLinks === void 0 ? [] : _props$navLinks,
      _props$iconLinks = props.iconLinks,
      iconLinks = _props$iconLinks === void 0 ? [] : _props$iconLinks,
      logoLinkProps = props.logoLinkProps,
      drawerChildren = props.drawerChildren,
      navSlot = props.navSlot;
  var ConditionalContainer = withContainer ? Container : "div";
  var DefaultOrCustomLogo = Logo || DefaultLogo;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Drawer, {
    navLinks: navLinks,
    isOpen: isDrawerOpen,
    setIsOpen: setIsDrawerOpen,
    hideQuoteButton: true,
    navSlot: navSlot
  }, drawerChildren), /*#__PURE__*/React.createElement(TierOne, null, /*#__PURE__*/React.createElement(ConditionalContainer, null, /*#__PURE__*/React.createElement(Columns, {
    align: "right"
  }, /*#__PURE__*/React.createElement(ColumnPullLeft, {
    width: "content",
    flex: true
  }, /*#__PURE__*/React.createElement(LogoLink, _extends({
    href: "/",
    id: "ga-nav-logo"
  }, logoLinkProps), /*#__PURE__*/React.createElement(DefaultOrCustomLogo, null))), /*#__PURE__*/React.createElement(HiddenBelowXLFlexAbove, null, isSingleTier && navLinks && /*#__PURE__*/React.createElement(UnstyledUnorderedList, null, navLinks.map(function (link, i) {
    var slug = link.slug,
        url = link.url,
        otherProps = _objectWithoutProperties(link, _excluded2);

    return /*#__PURE__*/React.createElement(NavLinkItem, _extends({
      key: "".concat(slug, "-").concat(i),
      link: link,
      href: url,
      activePage: props.activePage,
      navLink: NavLink,
      dropdownIconSize: 20
    }, otherProps), link.title);
  })), iconLinks && /*#__PURE__*/React.createElement(UnstyledUnorderedList, null, iconLinks.map(function (link) {
    var id = link.id,
        title = link.title,
        slug = link.slug,
        url = link.url,
        Icon = link.icon,
        onClick = link.onClick,
        otherProps = _objectWithoutProperties(link, _excluded3);

    return /*#__PURE__*/React.createElement(FlexListItem, {
      key: slug
    }, /*#__PURE__*/React.createElement(IconLink, _extends({
      href: url,
      icon: Icon,
      id: "".concat(id, "-desktop"),
      onClick: onClick && onClick
    }, otherProps), title));
  }))), /*#__PURE__*/React.createElement(FlexBelowXLHiddenAbove, null, /*#__PURE__*/React.createElement(Column, {
    flex: true
  }, iconLinks && iconLinks.map(function (link, i) {
    var id = link.id,
        title = link.title,
        slug = link.slug,
        url = link.url,
        icon = link.icon,
        onClick = link.onClick,
        component = link.component,
        otherProps = _objectWithoutProperties(link, _excluded4);

    var Icon = icon;
    return /*#__PURE__*/React.createElement(HeaderLink, _extends({
      key: "".concat(slug, "-").concat(i),
      href: url,
      icon: Icon,
      id: "".concat(id, "-mobile"),
      "aria-label": title,
      component: component || "a",
      onClick: onClick && onClick
    }, otherProps), /*#__PURE__*/React.createElement(Icon, null));
  }), /*#__PURE__*/React.createElement(HeaderLink, {
    component: "button",
    id: "ga-nav-menu-mobile",
    onClick: function onClick() {
      setIsDrawerOpen(true);
    },
    "aria-label": "Open menu"
  }, /*#__PURE__*/React.createElement(MenuSystemIcon, {
    fill: "#434343"
  }))))))), !isSingleTier && /*#__PURE__*/React.createElement(Hidden, {
    below: "xl"
  }, /*#__PURE__*/React.createElement(TierTwo, null, /*#__PURE__*/React.createElement(ConditionalContainer, null, /*#__PURE__*/React.createElement(NavMenu, null, navLinks && navLinks.map(function (link) {
    return /*#__PURE__*/React.createElement(NavLinkItem, _extends({
      link: link,
      activePage: activePage,
      key: link.id
    }, link, {
      navLink: NavLink,
      dropdownIconSize: 20
    }));
  }), navSlot && navSlot)))));
};
PortalHeader.displayName = "PortalHeader";
PortalHeader.defaultProps = {
  withContainer: false,
  isSingleTier: false
};